import debug from 'debug';
import Breakpoints from 'Minetilbud/Shared/Components/Breakpoints/Breakpoints';

const log = debug('BoostBanner:Render:Templates');
const breakpoints = new Breakpoints();

class Templates {

	frontPageHero({ clickTarget, externalId, images, link, targetGroup, title }, scale, siteWidth) {
		let filteredImages = images.filter(image => image.targetDevice.name === 'Mobile');

		if (breakpoints.MediaBreakpointUp('md')) {
			filteredImages = images.filter(image => image.targetDevice.name === 'Desktop');
		}

		if (filteredImages.length === 0) {
			log('filteredImages has not the requested "bannerLocationImageRuleId" / "targetDevice ');
			return;
		}

		const target = clickTarget === 'NewWindow' ? '_blank' : '_self';

		return `
			<section class="o-boost-banner-image" data-id="${externalId}" data-target-group="${targetGroup.name}" data-name="${title}">
				<a class="o-boost-banner-image__link" href="${link}" target="${target}" title="${title}" data-id="${externalId}">
					<img class="o-boost-banner-image__desktop-image" width="${siteWidth}" height="${siteWidth/parseFloat(filteredImages[0].aspectratio)}" src="${filteredImages[0].imageUrl}?w=${siteWidth * scale}" alt="${title}">
				</a>
			</div>
		`;
	}

	frontPageInspiration({ clickTarget, externalId, images, link, targetGroup, title }, scale, siteWidth) {
		let filteredImages = images.filter(image => image.targetDevice.name === 'Mobile');

		if (breakpoints.MediaBreakpointUp('md')) {
			filteredImages = images.filter(image => image.targetDevice.name === 'Desktop');
		}

		if (filteredImages.length === 0) {
			log('filteredImages has not the requested "bannerLocationImageRuleId" / "targetDevice ');
			return;
		}

		const target = clickTarget === 'NewWindow' ? '_blank' : '_self';

		return `
			<section class="o-boost-banner-image" data-id="${externalId}" data-target-group="${targetGroup.name}" data-name="${title}">
				<a class="o-boost-banner-image__link" href="${link}" target="${target}" title="${title}" data-id="${externalId}">
					<img class="o-boost-banner-image__desktop-image" width="${siteWidth}" height="${siteWidth/parseFloat(filteredImages[0].aspectratio)}" src="${filteredImages[0].imageUrl}?w=${siteWidth * scale}" alt="${title}">
				</a>
			</div>
		`;
	}
}

export default Templates;
